import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export const useGetQuestionByIdQuery = (id: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.questions.detail(id || ''),
    queryFn: () =>
      apiClient.get('/api/admin/questions/{questionId}', { pathParams: { questionId: id! } }),
    enabled: !!id,
    select: data => data?.question,
  });
};
